var $bebb5f3cb64a9781$exports = {};
!function(t, e) {
    $bebb5f3cb64a9781$exports = e();
}($bebb5f3cb64a9781$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = function(t) {
        return t instanceof b;
    }, S = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, w = function(t, e) {
        if (p(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new b(n);
    }, O = v;
    O.l = S, O.i = p, O.w = function(t, e) {
        return w(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var b = function() {
        function M(t) {
            this.$L = S(t.locale, null, !0), this.parse(t);
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (O.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.$x = t.x || {}, this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return O;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = w(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return w(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < w(t);
        }, m.$g = function(t, e, n) {
            return O.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!O.u(e) || e, f = O.p(t), l = function(t, e) {
                var i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return O.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = O.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[O.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = O.p(f), y = function(t) {
                var e = w(l);
                return O.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return O.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = O.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return O.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return O.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return O.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return O.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return O.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return O.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return O.s(e.$s, 2, "0");
                        case "SSS":
                            return O.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = O.p(d), m = w(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return O.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : O.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = S(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return O.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), _ = b.prototype;
    return w.prototype = _, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        _[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), w.extend = function(t, e) {
        return t.$i || (t(e, b, w), t.$i = !0), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function(t) {
        return w(1e3 * t);
    }, w.en = D[g], w.Ls = D, w.p = {}, w;
});


var $8e2e75cb547a7c44$exports = {};
!function(e, t) {
    $8e2e75cb547a7c44$exports = t();
}($8e2e75cb547a7c44$exports, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});


var $a2bec1e4479b2feb$exports = {};
!function(e, t) {
    $a2bec1e4479b2feb$exports = t();
}($a2bec1e4479b2feb$exports, function() {
    "use strict";
    return function(e, t) {
        t.prototype.weekday = function(e) {
            var t = this.$locale().weekStart || 0, i = this.$W, n = (i < t ? i + 7 : i) - t;
            return this.$utils().u(e) ? n : this.subtract(n, "day").add(e, "day");
        };
    };
});


$bebb5f3cb64a9781$exports.extend($8e2e75cb547a7c44$exports);
$bebb5f3cb64a9781$exports.extend($a2bec1e4479b2feb$exports);
const $b4e14b6b8da86996$var$DAYS = {
    sun: 7,
    mon: 1,
    tue: 2,
    wed: 3,
    thu: 4,
    fri: 5,
    sat: 6
};
const $b4e14b6b8da86996$var$readQueryParams = ()=>{
    const searchParams = new URL(window.location.href).searchParams;
    const dayParam = searchParams.get("day");
    const day = dayParam && dayParam in $b4e14b6b8da86996$var$DAYS ? $b4e14b6b8da86996$var$DAYS[dayParam] : 1;
    const redParam = searchParams.get("red");
    const yellowParam = searchParams.get("yellow");
    const greenParam = searchParams.get("green");
    // Validate frequency values
    const isValidFrequency = (freq)=>{
        return freq === "even" || freq === "odd" || freq === "both" || freq === "none";
    };
    let red = "both";
    let yellow = "even";
    let green = "odd";
    if (redParam !== null) {
        if (isValidFrequency(redParam)) red = redParam;
        else {
            console.warn(`Invalid frequency for red: "${redParam}". Defaulting to "both".`);
            red = "both";
        }
    }
    if (yellowParam !== null) {
        if (isValidFrequency(yellowParam)) yellow = yellowParam;
        else {
            console.warn(`Invalid frequency for yellow: "${yellowParam}". Defaulting to "even".`);
            yellow = "even";
        }
    } else yellow = "even";
    if (greenParam !== null) {
        if (isValidFrequency(greenParam)) green = greenParam;
        else {
            console.warn(`Invalid frequency for green: "${greenParam}". Defaulting to "odd".`);
            green = "odd";
        }
    } else green = "odd";
    return {
        day: day,
        red: red,
        yellow: yellow,
        green: green
    };
};
const $b4e14b6b8da86996$var$isEven = (value)=>value % 2 === 0;
const $b4e14b6b8da86996$var$isOdd = (value)=>!$b4e14b6b8da86996$var$isEven(value);
const $b4e14b6b8da86996$var$isDue = (weekNumber, frequency)=>{
    switch(frequency){
        case "even":
            return $b4e14b6b8da86996$var$isEven(weekNumber);
        case "odd":
            return $b4e14b6b8da86996$var$isOdd(weekNumber);
        case "both":
            return true;
        case "none":
            return false;
    }
};
const $b4e14b6b8da86996$var$updateColour = (date = $bebb5f3cb64a9781$exports())=>{
    const { day: day, red: red, yellow: yellow, green: green } = $b4e14b6b8da86996$var$readQueryParams();
    const binDay = $bebb5f3cb64a9781$exports().weekday(day).endOf("day");
    const weekNumber = $bebb5f3cb64a9781$exports().week();
    // Determine effective week: this week if before collection day, next week if after
    const effectiveWeek = weekNumber + (date > binDay ? 1 : 0);
    // Check which bins are due this effective week
    const dueBins = [];
    if ($b4e14b6b8da86996$var$isDue(effectiveWeek, red)) dueBins.push("red");
    if ($b4e14b6b8da86996$var$isDue(effectiveWeek, yellow)) dueBins.push("yellow");
    if ($b4e14b6b8da86996$var$isDue(effectiveWeek, green)) dueBins.push("green");
    console.debug(`Bin Night Debug:`, {
        day: day,
        red: red,
        yellow: yellow,
        green: green,
        weekNumber: weekNumber,
        effectiveWeek: effectiveWeek,
        dueBins: dueBins,
        date: date.format(),
        binDay: binDay.format(),
        isAfterCollection: date > binDay
    });
    // Update bin display
    const container = document.getElementById("bin-container");
    if (container) {
        // Ensure container is visible
        container.style.display = "flex";
        // Update each bin's color and visibility
        const colors = [
            "red",
            "yellow",
            "green"
        ];
        colors.forEach((color)=>{
            const bin = document.getElementById(`bin-${color}`);
            if (bin) {
                const isDue = dueBins.indexOf(color) !== -1;
                bin.style.display = isDue ? "flex" : "none";
                bin.style.backgroundColor = isDue ? color : "#ccc";
            }
        });
    }
};
const $b4e14b6b8da86996$var$run = ()=>{
    console.info("Bin Night - Collection Day Reminder");
    console.info('Required parameter: "day" (collection day)');
    console.info('  - One of "mon", "tue", "wed", "thu", "fri", "sat", "sun"');
    console.info("");
    console.info("Frequency parameters (optional, default shown):");
    console.info('  - "red"    : "even" | "odd" | "both" | "none" (default: "both")');
    console.info('  - "yellow" : "even" | "odd" | "both" | "none" (default: "even")');
    console.info('  - "green"  : "even" | "odd" | "both" | "none" (default: "odd")');
    console.info("");
    console.info("Examples:");
    console.info("  - New format: ?day=mon&red=both&yellow=even&green=odd");
    console.info("  - Weekly red: ?day=mon&red=both&yellow=none&green=none");
    console.info("");
    console.info("Shows which bins are due for the next collection.");
    // Ensure bin container exists
    const container = document.getElementById("bin-container");
    if (!container) {
        console.error("Bin container not found in HTML");
        return;
    }
    $b4e14b6b8da86996$var$updateColour();
    console.debug("Initial update complete");
    setInterval($b4e14b6b8da86996$var$updateColour, 60000);
};
$b4e14b6b8da86996$var$run();


//# sourceMappingURL=index.7ca38bfa.js.map
